import { useState, useEffect } from "react";
import axios from "axios";
import api from "../auth/api";


export default function MetaPages() {
  const [pages, setPages] = useState([]);
  const [connections, setConnections] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editingPage, setEditingPage] = useState(null);

  const fetchPages = async () => {
    const res = await api.get("/api/meta/pages");
    setPages(res.data);
  };

  const fetchConnections = async () => {
    const res = await api.get("/api/meta/connections");
    setConnections(res.data);
  };

  useEffect(() => {
    fetchPages();
    fetchConnections();
  }, []);

  const openEdit = (page) => {
    setEditingPage(page);
    setOpenDrawer(true);
  };

  const handleSync = async (connectionId) => {
    await api.get(`/api/meta/pages/sync/${connectionId}`);
    fetchPages();
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Páginas conectadas</h1>

        {/* Selector de conexión para sincronizar */}
        <div className="flex gap-2">
          <select id="connectionSelect" className="border p-2 rounded">
            <option value="">Seleccionar conexión</option>
            {connections.map((c) => (
              <option key={c.id} value={c.id}>
                Meta User {c.meta_user_id}
              </option>
            ))}
          </select>

          <button
            onClick={() => {
              const id = document.getElementById("connectionSelect").value;
              if (!id) return alert("Seleccione una conexión primero.");
              handleSync(id);
            }}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            🔄 Sincronizar Páginas
          </button>
        </div>
      </div>

      {/* Tabla */}
      <div className="overflow-x-auto border rounded-lg">
        <table className="w-full text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3">Página</th>
              <th className="p-3">Page ID</th>
              <th className="p-3">Conexión</th>
              <th className="p-3">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {pages.map((p) => (
              <tr key={p.id} className="border-b">
                <td className="p-3">{p.page_name}</td>
                <td className="p-3">{p.page_id}</td>
                <td className="p-3">ID {p.meta_connection_id}</td>
                <td className="p-3">
                  <button
                    onClick={() => openEdit(p)}
                    className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Ver / Permisos
                  </button>
                </td>
              </tr>
            ))}

            {pages.length === 0 && (
              <tr>
                <td colSpan="4" className="p-3 text-gray-500 italic">
                  No hay páginas conectadas.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {openDrawer && (
        <MetaPageDrawer
          page={editingPage}
          onClose={() => setOpenDrawer(false)}
        />
      )}
    </div>
  );
}

/* Drawer */
function MetaPageDrawer({ page, onClose }) {
  return (
    <div className="fixed inset-0 flex justify-end bg-black bg-opacity-30">
      <div className="w-full sm:w-[450px] bg-white h-full shadow-xl p-6 animate-slideIn">
        <h2 className="text-xl font-semibold mb-4">Detalle de Página</h2>

        <p><b>Nombre:</b> {page.page_name}</p>
        <p><b>Page ID:</b> {page.page_id}</p>
        <p><b>Conexión Meta ID:</b> {page.meta_connection_id}</p>

        <div className="mt-6 pt-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-lg hover:bg-gray-100"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
